import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTeacherBookings,
  cancelTeacherBooking,
  archiveTeacherBooking,
  unarchiveTeacherBooking,
} from "./operation.js";

const initialState = {
  activeBookings: [],
  archived: {
    bookings: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
  },
  loading: false,
  error: null,
};

const teacherBookingsSlice = createSlice({
  name: "teacherBookings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🔄 Загрузка
      .addCase(fetchTeacherBookings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherBookings.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        if (action.payload.mode === "active") {
          state.activeBookings = action.payload.bookings;
        } else if (action.payload.mode === "archived") {
          state.archived = {
            bookings: action.payload.bookings,
            total: action.payload.total,
            totalPages: action.payload.totalPages,
            currentPage: action.payload.currentPage,
          };
        }
      })
      .addCase(fetchTeacherBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ❌ Отмена → сразу архив
      .addCase(cancelTeacherBooking.fulfilled, (state, action) => {
        const id = action.payload.bookingId;
        state.activeBookings = state.activeBookings.map((b) =>
          b.booking_id === id
            ? {
                ...b,
                status: "cancelled",
                cancelled_by: "teacher",
                cancelled_at: action.payload.cancelled_at,
                archived: true,
              }
            : b
        );
      })

      // 📥 Архивация
      .addCase(archiveTeacherBooking.fulfilled, (state, action) => {
        const id = action.payload;
        const target = state.activeBookings.find((b) => b.booking_id === id);
        if (target) {
          target.archived = true;
          state.archived.bookings.push(target);
          state.activeBookings = state.activeBookings.filter(
            (b) => b.booking_id !== id
          );
        }
      })

      // 📤 Возврат из архива
      .addCase(unarchiveTeacherBooking.fulfilled, (state, action) => {
        const id = action.payload;
        const target = state.archived.bookings.find((b) => b.booking_id === id);
        if (target) {
          target.archived = false;
          state.activeBookings.push(target);
          state.archived.bookings = state.archived.bookings.filter(
            (b) => b.booking_id !== id
          );
        }
      });
  },
});

export default teacherBookingsSlice.reducer;
